// @flow
import * as React from 'react'
import getParkingSpotSuggestions from 'mz-sdk/services/travelcar/getParkingSpotSuggestions'
import PlaceField from 'mz-ui-kit/form/PlaceField'
import { wrapWithField } from '../Field'

// Types
import type { Props as SelectFieldProps } from '../SelectField'

type Props = SelectFieldProps & {
  placeholder?: React.Node,
}

/**
 * A field to select parking spot object.
 */
const ParkingSpotSearchField = (props: Props) => (
  <PlaceField {...props} customSuggestionsGetter={getParkingSpotSuggestions} />
)

export default wrapWithField(ParkingSpotSearchField)
